import * as React from 'react';
import { Link } from 'gatsby';
import { Location } from '@reach/router';
import { createGlobalStyle, css } from 'styled-components';
import auth from '../../helpers/auth';
import {
    KIRKOSWALD_ASSET_MANAGEMENT_LLC,
    KIRKOSWALD_CAPITAL_MANAGEMENT_LIMITED,
    KIRKOSWALD_CAPITAL_PARTNERS_LLP,
} from '../../constants/constants';
import {
    activeNavLink,
    hiddenNavigationMenuWrapper,
    legalSection,
    legalSectionCopyright,
    copyrightTitle,
    linkTitle,
    navigationMenu,
    navigationMenuOpen,
    navigationMenuWrapper,
    navLink,
    navLinks,
    navButton
} from './NavigationMenu.module.scss';

const BodyOverflowControl = createGlobalStyle`
  @keyframes fadeOutBackground {
      from {background-color:rgba(31, 59, 45, 0.8);}
      to {background-color:rgba(31, 59, 45, 0);}
  }
  ${({ blockScroll }) =>
      blockScroll &&
      css`
          body {
              overflow: hidden;
          }
          .headroom--unpinned {
              // use animation to fade background color to prevent flicker on close
              animation: fadeOutBackground 0.5s forwards;
          }
      `}`;

const PageLink = ({ to, title, active, closeMenu }) => (
    // Only close navigation menu if same page selected
    <li>
        <Link onClick={active ? closeMenu : undefined} className={active ? activeNavLink : navLink} to={to}>
            <span className={linkTitle}>{title}</span>
        </Link>
    </li>
);

export default function NavigationMenu({ open, closeMenu }) {
    const scrollToFooter = React.useCallback(() => {
        closeMenu();
        if (typeof window === 'undefined') {
            return;
        }
        window.requestAnimationFrame(() => {
            const footer = document.querySelector('footer');
            if (footer && typeof footer.scrollIntoView === 'function') {
                footer.scrollIntoView({ behavior: 'smooth' });
            }
        });
    }, [closeMenu]);

    return (
        <>
            <BodyOverflowControl blockScroll={open} />
            <div className={open ? navigationMenuOpen : navigationMenu}>
                <div className={open ? navigationMenuWrapper : hiddenNavigationMenuWrapper}>
                    <Location>
                        {({ location }) => {
                            return (
                                <ul className={navLinks}>
                                    <PageLink to="/" title="Home" active={location.pathname === '/'} closeMenu={closeMenu} />
                                    <PageLink
                                        to="/strategies/"
                                        title="Strategies"
                                        active={location.pathname === '/strategies/'}
                                        closeMenu={closeMenu}
                                    />
                                    {auth().isAuthenticated() && (<PageLink
                                        to="/insights/"
                                        title="Insights"
                                        active={location.pathname === '/insights/'}
                                        closeMenu={closeMenu}
                                    />)}
                                    <PageLink
                                        to="/contact/"
                                        title="Contact"
                                        active={location.pathname === '/contact/'}
                                        closeMenu={closeMenu}
                                    />
                                    <li>
                                        <button type="button" className={navButton} onClick={scrollToFooter}>
                                            <span className={linkTitle}>Disclosures</span>
                                        </button>
                                    </li>
                                    {auth().isAdmin() && (
                                        <PageLink
                                            to="/portal/admin"
                                            title="Admin"
                                            active={location.pathname === '/portal/admin/dashboard'}
                                            closeMenu={closeMenu}
                                        />
                                    )}
                                    {auth().isAuthenticated() && <PageLink to="/login/logout" title="Logout" closeMenu={closeMenu} />}
                                </ul>
                            );
                        }}
                    </Location>
                    <div className={legalSection}>
                        <p className={copyrightTitle}>
                            Copyright
                        </p>
                        <span className={legalSectionCopyright}>&copy; {KIRKOSWALD_CAPITAL_PARTNERS_LLP}</span>
                        <span className={legalSectionCopyright}>&copy; {KIRKOSWALD_CAPITAL_MANAGEMENT_LIMITED}</span>
                        <span className={legalSectionCopyright}>&copy; {KIRKOSWALD_ASSET_MANAGEMENT_LLC}</span>
                    </div>
                </div>
            </div>
        </>
    );
}
